import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Montserrat', sans-serif`,
    body: `'Montserrat', sans-serif`,
  },
  styles: {
    global: {
      'html, body, #root': {
        height: '100%',
        minH: '100%',
        color: 'gray.700',
      },
      body: {
        bg: 'gray.50',
      },
    },
  },
});

export default theme;
